// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"FeedbackFrontDesk--next-sr-only--2WNJp1m","mobileFeedbackPage":"FeedbackFrontDesk--mobileFeedbackPage--3oXfdM8"};